const app = new WindowQuery({mobile: '0px', desktop: '1024px'});

const navToggleBtn = document.getElementById('nav-toggle');
const openBtn = navToggleBtn.querySelector('.open');
const closeBtn = navToggleBtn.querySelector('.close');
const content = document.getElementById("nav-content");
let open = false;

const menuOpen = () => {
  let tl = gsap.timeline();
  let scrollHeight = content.scrollHeight;
  tl.to(content, {duration: 0.3, height: scrollHeight});
  open = true;
}
const menuClose = () => {
  let tl = gsap.timeline();
  let scrollHeight = content.scrollHeight;
  tl.to(content, {duration: 0.2, height: 0});
  open = false;
}

navToggleBtn.addEventListener('click', (e) => {
  e.preventDefault();

  open ? menuClose() : menuOpen();   

  closeBtn.classList.toggle("hidden");
  openBtn.classList.toggle("hidden");
});

const initSearch = () => {
  const searchBar = document.querySelector("#header-search");
  const searchBarBtn = document.querySelector("[data-to='header-search']");
  const searchInput = searchBar.querySelector("input[type='text']");
  const closeBtn = searchBar.querySelector("button");

  searchBarBtn.addEventListener('click', (e) => {
    e.preventDefault();
    let tl = gsap.timeline();
    tl.to(searchBar, { autoAlpha: 1, display: 'flex', y: 0, duration: 0.3 }, 0);
    searchInput.focus();
  });

  closeBtn.addEventListener('click', (e) => {
    e.preventDefault();
    let tl = gsap.timeline();
    tl.to(searchBar, { autoAlpha: 0, y: -150, duration: 0.3 });
  });
}

app.init();
initSearch();

const collectionDropdown = (() => {
  const btn = document.getElementById("collection-dropdown");
  const target = document.getElementById("collection-dropdown-content");
  const targetHeight = target.querySelector(".\\@content").scrollHeight;
  const links = target.querySelectorAll("li");

  target.style.top = content.scrollHeight + 'px';

  btn.addEventListener('mouseenter', (e) => {

    console.dir(target);
    let tl = gsap.timeline();
    tl.to(target, { height: targetHeight, duration: 0.3, ease: 'power4.out' }, 0);
  });
  
  btn.addEventListener('mouseleave', (e) => {
    let tl = gsap.timeline();
    tl.to(target, { height: 0, duration: 0.2 }, 0);
  });
})();